// extracted by mini-css-extract-plugin
export var actionButton = "_ml-0";
export var actionMenuContainer = "_ml-i";
export var bubble = "_ml-2";
export var bubbleActionMenu = "_ml-j";
export var bubbleContext = "_ml-6";
export var bubbleItems = "_ml-7";
export var customer = "_ml-3";
export var divider = "_ml-8";
export var fileList = "_ml-9";
export var hiddenComment = "_ml-o";
export var infoAbove = "_ml-a";
export var internal = "_ml-4";
export var lightActionButton = "_ml-1";
export var link = "_ml-b";
export var merchant = "_ml-5";
export var message = "_ml-c";
export var profilePicture = "_ml-e";
export var quillToolbarContainer = "_ml-f";
export var senderDate = "_ml-g";
export var senderDateCustomer = "_ml-h";
export var senderName = "_ml-d";
export var time = "_ml-k";
export var uploadedImage = "_ml-l";
export var username = "_ml-m";
export var xsmall = "_ml-n";